import { useResizeObserver as f } from "@bedrock-layout/use-resize-observer";
import l from "react";
function h(a, r = 1, e) {
  if (e !== void 0 && e <= r)
    throw new Error(
      `The second width value, ${e}, is not larger than ${r}. Please provide a value greater than first width value`
    );
  const [i, c] = l.useState(!1);
  return f((o) => {
    var n, s;
    const t = (s = (n = o.borderBoxSize) == null ? void 0 : n.inlineSize) != null ? s : o.contentRect.width;
    if (t > 0) {
      const u = e === void 0 ? t <= r : t >= r && t <= e;
      c(u);
    }
  }, a), i;
}
export {
  h as default,
  h as useContainerQuery
};
